import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-8" }
const _hoisted_4 = { class: "card-title mt-0" }

import getIttenkoAssociationResponse from "@/types/responses/getIttenkoAssociation";
import getIttenkoAssociationRequest from "@/types/requests/getIttenkoAssociation";
import getPaginatedAccountResponse from "@/types/responses/getPaginatedAccounts";
import SearchFilter from '@/components/TenkoAssociations/SearchFilter.vue';
import AccountList from '@/components/TenkoAssociations/AccountList.vue';
import DeleteModal from "@/components/TenkoAssociations/DeleteModal.vue";
import EditModal from "@/components/TenkoAssociations/EditModal.vue";
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi";
import { useAuth } from "@/services/user/Auth0UserProvider";
import PaginateWithCount from "@/components/PaginateWithCount.vue";
import { Ref, ref, reactive, watch, onMounted } from 'vue';
import { OPERATION_OFFICE_TYPE } from '@/services/consts';
import Api from "@/services/api/ApiServiceFabrick";
import accountType from "@/types/account";
import i18n from '@/lang/i18n';

type filterParamsType = {
  type_class: string,
  officeable_id: number | undefined,
  account_name: string,
  department_id: number | undefined,
  role_id: number,
  status: string,
  page: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TenkoAssociation',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props

const TITLE = i18n.global.t('pages.tenkoAssociation.title')
document.title = TITLE

const { loginWithRedirect } = useAuth()
const isLoading: Ref<boolean> = ref(false)
const accounts: Ref<accountType[]> = ref([])
const selectedAccount: Ref<accountType | null> = ref(null)
const employeeCode: Ref<string> = ref('')
const tenkoAssociations: Ref<getIttenkoAssociationResponse[]> = ref([])
const selectTenkoAssociation: Ref<getIttenkoAssociationResponse | null> = ref(null)
const currentPage: Ref<number> = ref(1)
const totalPage: Ref<number> = ref(0)
const itemsPerPage: Ref<number> = ref(50)
const allElementsCount: Ref<number> = ref(0)
const isSearched: Ref<boolean> = ref(false)
const updateModalStatus: Ref<boolean> = ref(false)
const deleteModalStatus: Ref<boolean> = ref(false)
const isUpdateAuthority: Ref<boolean> = ref(false)
const isDeleteAuthority: Ref<boolean> = ref(false)
const isRegisteredTenkoAssociation: Ref<boolean> = ref(false)
const searchParams: filterParamsType = reactive({
  type_class: OPERATION_OFFICE_TYPE,
  officeable_id: undefined,
  account_name: '',
  department_id: undefined,
  role_id: 2,
  status: 'only-active',
  page: 1
})

onMounted(() => {
  getAuthorities()
})

async function getAuthorities() {
  const authorityList = await AuthorityCacheApi.getWithParse();
  isUpdateAuthority.value = !!authorityList['octlink.it_tenko.update'];
  isDeleteAuthority.value = !!authorityList['octlink.it_tenko.delete'];
}

async function getAccounts(params: filterParamsType, page = 1) {
  getAccountParams(params, page)
  await Api().getPaginatedAccounts(searchParams).then((data: getPaginatedAccountResponse) => {
    accounts.value = data.accounts
    currentPage.value = data.current_page
    totalPage.value = data.total_page
    allElementsCount.value = data.total
    itemsPerPage.value = data.per_page
  }).catch((error) => {
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({ appState: { targetUrl: location.pathname } })
        break
      case 403:
        location.reload()
        break
    }
    isLoading.value = false
  })
}

async function getIttenkoAssociations(params: getIttenkoAssociationRequest) {
  await Api().getTenkoAssociations(params).then((data: getIttenkoAssociationResponse[]) => {
    tenkoAssociations.value = data
  }).catch((error) => {
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({ appState: { targetUrl: location.pathname } })
        break
      case 403:
        location.reload()
        break
    }
    isLoading.value = false
  })
}

async function filter(params: filterParamsType) {
  isLoading.value = true
  isSearched.value = true

  await Promise.all([
    getAccounts(params),
    getIttenkoAssociations(makeTenkoAssociationParams(params))
  ])
  isLoading.value = false
}

function getAccountParams(params: filterParamsType, page: number) {
  searchParams.officeable_id = params.officeable_id ?? undefined
  searchParams.department_id = params.department_id ?? undefined
  searchParams.account_name = params.account_name
  searchParams.page = page
}

function makeTenkoAssociationParams(params: filterParamsType) {
  return {
    operation_office_id: params.officeable_id
  }
}

function openUpdateModal(account: accountType, employeeCd: string, isRegistered: boolean) {
  selectedAccount.value = account
  employeeCode.value = employeeCd
  isRegisteredTenkoAssociation.value = isRegistered
  updateModalStatus.value = true
}

function openDeleteModal(tenkoAssociation: getIttenkoAssociationResponse) {
  selectTenkoAssociation.value = tenkoAssociation
  deleteModalStatus.value = true
}

async function updateSuccess() {
  updateModalStatus.value = false
  isLoading.value = true
  props.showFlash(i18n.global.t('pages.common.messages.successUpdate'), 'success', true)
  await getIttenkoAssociations(makeTenkoAssociationParams(searchParams))
  isLoading.value = false
}

async function deleteSuccess() {
  deleteModalStatus.value = false
  isLoading.value = true
  props.showFlash(i18n.global.t('pages.common.messages.successDelete'), 'success', true)
  await getIttenkoAssociations(makeTenkoAssociationParams(searchParams))
  isLoading.value = false
}

async function deleteFailed() {
  deleteModalStatus.value = false
  isLoading.value = true
  await getIttenkoAssociations(makeTenkoAssociationParams(searchParams))
  isLoading.value = false
}

watch(() => currentPage.value, async() => {
  isLoading.value = true
  await getAccounts(searchParams, currentPage.value)
  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(TITLE)), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(AccountList, {
          class: "mb-2",
          accounts: accounts.value,
          tenkoAssociations: tenkoAssociations.value,
          isSearched: isSearched.value,
          isLoading: isLoading.value,
          isUpdateAuthority: isUpdateAuthority.value,
          isDeleteAuthority: isDeleteAuthority.value,
          onOpenUpdateModal: openUpdateModal,
          onOpenDeleteModal: openDeleteModal
        }, null, 8, ["accounts", "tenkoAssociations", "isSearched", "isLoading", "isUpdateAuthority", "isDeleteAuthority"]),
        _createVNode(PaginateWithCount, {
          class: "justify-end",
          totalPage: totalPage.value,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
          itemsPerPage: itemsPerPage.value,
          allElementsCount: allElementsCount.value,
          showItemCount: true
        }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"]),
        (updateModalStatus.value)
          ? (_openBlock(), _createBlock(EditModal, {
              key: 0,
              modelValue: updateModalStatus.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updateModalStatus).value = $event)),
              account: selectedAccount.value,
              employeeCode: employeeCode.value,
              isRegistered: isRegisteredTenkoAssociation.value,
              onSuccess: updateSuccess
            }, null, 8, ["modelValue", "account", "employeeCode", "isRegistered"]))
          : _createCommentVNode("", true),
        (deleteModalStatus.value)
          ? (_openBlock(), _createBlock(DeleteModal, {
              key: 1,
              modelValue: deleteModalStatus.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((deleteModalStatus).value = $event)),
              tenkoAssociation: selectTenkoAssociation.value,
              onSuccess: deleteSuccess,
              onDeleteFailed: deleteFailed
            }, null, 8, ["modelValue", "tenkoAssociation"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(SearchFilter, {
      loading: isLoading.value,
      onSearch: filter
    }, null, 8, ["loading"])
  ]))
}
}

})